import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import kenya from "./../../kenya.png";
import login from "./login.css";
const api = axios.create({
  //  baseURL: "http://localhost:8000",
  //  baseURL: "http://103.13.211.35:82",
  baseURL: "http://102.220.22.97:8000",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Accept: "*/*",
  },
});
const Login = (props) => {
  const [inputs, setInputs] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [userType, setUserType] = useState("PUBLIC_USER");
  const handleSubmit = (event) => {
    event.preventDefault();
    setDisabled(true);

    let data = JSON.stringify(inputs);
    api.post("/authenticate", data).then(
      (response) => {
        setDisabled(false);
        if (response.status == "200") {
          let data = response.data;
          let user = data.user;

          window.sessionStorage.setItem("xtoken", data.token);
          window.sessionStorage.setItem(
            "SecurityGroupId",
            user.securityGroupId,
          );
          window.sessionStorage.setItem("UserId", user.id);
          window.sessionStorage.setItem("Photo", user.userPhoto);
          window.sessionStorage.setItem("UserName", user.username);
          window.sessionStorage.setItem(
            "Institutionname",
            "Ministry of Tourism and Wildlife",
          );
          window.location.reload();
          return (window.location = "#/");
        } else {
          swal("", "Account not found or Invalid login details", "error");
        }
      },
      (error) => {
        setDisabled(false);
        swal("", "Login Failed", "error");
      },
    );
  };
  const handleresetpassword = (url) => {
    let data = JSON.stringify({ email: inputs.username });
    api.get(url, data).then(
      (response) => {
        let data = response.data;
        if (data.resultCode === "00") {
          swal(
            "",
            data.description + " New password sent to your email",
            "success",
          );
        } else {
          swal("", data.description, "error");
        }
      },
      (error) => {
        swal("", "Request Failed", "error");
      },
    );
  };
  const handlereset = () => {
    if (inputs.username) {
      handleresetpassword("/api/forgotPassword?userName=" + inputs.username);
    } else {
      alert("Email is required");
    }
  };
  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({
      ...inputs,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <div className="container-flex min-vh-100 p-0">
      <div className="row min-vh-100 g-0">
        {/* LEFT SIDE */}
        <div
          //className="col-md-6 d-none d-md-flex flex-column justify-content-center text-white p-5"
          className="col-md-6 d-md-flex rounded-0 flex-column justify-content-center text-white p-0"
          style={{ background: "#0d5a43", borderRadius: "0px !important" }}
        >
          <div style={{ maxWidth: "400px", margin: "0 auto" }}>
            {/* LOGO */}

            <img src={kenya} alt="" style={{ width: "100%" }} />

            <br />
            <br />
            <p
              className="text-light text-left"
              style={{ fontSize: "18px", lineHeight: "1.8" }}
            >
              Empowering Kenya's tourism sector through efficient, unified and
              secure digital services
            </p>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div
          className="col-md-6 d-flex align-items-center justify-content-center bg-light"
          style={{ padding: "30px", width: "100% !important" }}
        >
          <div
            //className="bg-white rounded-4 shadow p-4 w-100"
            style={{ maxWidth: "80%" }}
          >
            <h2 className="fw-bold mb-1 flex">Welcome back</h2>
            <h2
              className="align-left fw-bold mb-1"
              style={{
                fontSize: "15px",
                textAlign: "left",
              }}
            >
              Please enter your details to sign in.
            </h2>

            {/* INFO BOX WITH ICON */}
            <div
              className="rounded-3 p-4 mb-4 d-flex align-items-center"
              style={{
                background: "#f3f6ff00",
                border: "1px solid #789beb",
                fontSize: "13px",
                color: "#789beb",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#789beb"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ marginRight: "10px", flexShrink: 0 }}
              >
                <path d="M12 2a10 10 0 0 0-10 10c0 4.2 2.6 7.8 6.3 9.3.5.2.7-.1.7-.4v-1.6c-2.6.6-3.2-1.1-3.2-1.1-.4-1.1-1-1.4-1-1.4-.8-.6 0-.6 0-.6.9.1 1.4.9 1.4.9.8 1.4 2.1 1 2.6.8.1-.6.3-1 .5-1.2-2-.2-4.1-1-4.1-4.4 0-1 .3-1.8.9-2.4-.1-.2-.4-1.1.1-2.3 0 0 .7-.2 2.4.9a8.3 8.3 0 0 1 4.4 0c1.7-1.1 2.4-.9 2.4-.9.5 1.2.2 2.1.1 2.3.6.6.9 1.4.9 2.4 0 3.4-2.1 4.2-4.1 4.4.3.3.6.8.6 1.6v2.4c0 .3.2.6.7.4 3.7-1.5 6.3-5.1 6.3-9.3 0-5.5-4.5-10-10-10z" />
              </svg>
              <span>
                Use this account type to report security incidents quickly.
              </span>
            </div>

            {/* FORM */}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label fw-semibold">Email Address</label>
                <div className="position-relative">
                  <span className="position-absolute start-0 icon-position top-50 translate-middle-y ms-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#6c757d"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    onChange={handleInputChange}
                    defaultValue={inputs.username}
                    placeholder="you@example.com"
                    required
                    style={{ paddingLeft: "45px" }}
                  />
                </div>
              </div>

              <div className="mb-2">
                <label className="form-label fw-semibold">Password</label>
                <div className="position-relative">
                  <span className="position-absolute icon-position start-0 top-50 translate-middle-y ms-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#6c757d"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    onChange={handleInputChange}
                    defaultValue={inputs.password}
                    placeholder="********"
                    required
                    style={{ paddingLeft: "45px" }}
                  />
                </div>
              </div>

              {/* REMEMBER + RESET */}
              <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="remember"
                  />
                  <label
                    className="form-check-label text-muted"
                    htmlFor="remember"
                  >
                    Remember me
                  </label>
                </div>

                <span
                  style={{
                    cursor: "pointer",
                    color: "#198754",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                  onClick={handlereset}
                >
                  Forgot password?
                </span>
              </div>

              {/* LOGIN BUTTON */}
              <button
                type="submit"
                className="btn btn-success w-100 py-2 fw-bold rounded-3"
                disabled={disabled}
              >
                Sign In
              </button>

              {/* REGISTER */}
              <div className="text-center text-muted mt-4">
                <p className="fontsize: {}">
                  Don’t have an account?{" "}
                  <Link
                    to="/SelfRegistration"
                    className="text-success fw-bold text-decoration-none"
                  >
                    Sign up
                  </Link>
                </p>
              </div>

              <hr className="my-4" />

              <p className="text-center text-muted mb-0">
                &copy; 2026 Ministry of Tourism & Wildlife
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
